module.exports = __webpack_public_path__ + "img/courses5.b869ff6d.jpg";